import {
  GhostButton,
  PrimaryButton,
  SecondaryTopNav,
} from "@certn/cascadia-react";
import { t } from "i18next";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { LeverIntegrationContext } from "../LeverIntegrationContext";

interface Props {
  onComplete?: () => void;
  isDisabled?: boolean;
  submitting?: boolean;
}

export function LeverIntegrationStepHeader({
  onComplete,
  isDisabled,
  submitting,
}: Props) {
  const navigate = useNavigate();
  const { goToPrevStep, currentStep } = useContext(LeverIntegrationContext);

  const cancel = () => {
    navigate("/settings/ats-integrations");
  };

  return (
    <SecondaryTopNav
      testID="lever-integration-setup-top-nav"
      leftIcon={currentStep === 0 ? "close" : "arrow_back"}
      onleftIconOnPress={currentStep === 0 ? cancel : goToPrevStep}
    >
      {currentStep > 0 && (
        <GhostButton
          onPress={cancel}
          testID="lever-integration-setup-top-nav-cancel-button"
        >
          {t("Cancel")}
        </GhostButton>
      )}
      <PrimaryButton
        onPress={onComplete}
        isDisabled={isDisabled}
        isLoading={submitting}
        testID="lever-integration-setup-top-nav-next-step-button"
      >
        {currentStep === 0 ? t("Validate API key") : t("Complete setup")}
      </PrimaryButton>
    </SecondaryTopNav>
  );
}
